import type React from 'react'
import styled from 'styled-components'

export interface Props {
  active?: boolean
  onClick?: Function
}

const FilterTag = styled.li<{ active?: boolean }>`
  display: flex;
  justify-content: space-evenly;
  padding: 7px;
  background: ${p => (p.active ? '#34bebd' : '')};
  color: ${p => (p.active ? 'white' : '#082842')};
  border-radius: 5px;
  border: ${p => (p.active ? `solid 1px #34bebd` : 'solid 1px #082842')};
  width: 100px;
  font-weight: 500;
  font-size: 0.8rem;
  max-height: 32px;
  text-align: center;
  align-items: center;
  transition: background-color 59ms linear;

  img {
    max-width: 24px;
    height: auto;
  }

  &:hover {
    cursor: pointer;
  }
`

const PillButton: React.FC<Props> = ({
  children,
  active = false,
  onClick = () => {},
}) => {
  return (
    <FilterTag onClick={() => onClick()} active={active}>
      {children}
    </FilterTag>
  )
}

export default PillButton
